import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '@/views/login/login'
import index from '@/views/index/index'
import center from '@/views/center/center'
import myQuestionCourse from '@/views/questionCourse/myQuestionCourse'
import chapterQuestion from '@/views/questionCourse/chapterQuestion.vue'
import quiuzQuestion from '@/views/questionCourse/quiuzQuestion.vue'
import paperRecord from '@/views/paperRecord/paperRecord.vue'
import paperReport from '@/views/paperRecord/paperReport.vue'
import about from '@/views/about/about'

import error404 from '@/views/error/404'
import myClass from "@/views/class/myClass.vue";
import myClassInfo from "@/views/class/myClassInfo.vue";
import courseQuestionDetail from "@/views/questionCourse/courseQuestionDetail.vue"
import courseDetail from "@/views/class/courseDetail.vue"
import classCourseDetail from "@/views/class/classCourseDetail.vue";
import AnnouncementDetail from "@/views/index/announcementDetail.vue";

Vue.use(VueRouter)


const routes = [
    {
        path: '/',
        redirect: '/index' // 默认跳转到首页
    },
    {
        path: '/index',
        name: 'index',
        component: index,
        meta: { requiresAuth: false } // 首页不需要登录
    },
    {
        path: '/detail/:id',
        name: 'announcementDetail',
        component: AnnouncementDetail,
        props: true
    },
    {
        path: '/myClass',
        name: 'myClass',
        component: myClass,
        meta: { requiresAuth: true } // 班级页面需要登录
    },
    {
        path: '/myClassInfo/:classId/:className/:classImg',
        name: 'myClassInfo',
        component: myClassInfo,  // 这个是课程详细页面的组件
        props: true // 允许将路由参数作为 props 传递给组件
    },
    {
        path: '/myClassInfo/:courseId/:classId/:courseImg/:courseName',
        name: 'classCourseDetail',
        component: classCourseDetail,
        props: true
    },
    {
        path: '/login',
        name: 'login',
        component: login,
        meta: { requiresAuth: false } // 登录页面不需要登录
    },
    {
        path: '/about',
        name: 'about',
        component: about,
        meta: { requiresAuth: false } // 关于页面不需要登录
    },
    {
        path: '/center',
        name: 'center',
        component: center,
        meta: { requiresAuth: true } // 个人中心页面需要登录
    },
    {
        path: '/myQuestionCourse',
        name: 'myQuestionCourse',
        component: myQuestionCourse,
        meta: { requiresAuth: true } // 题库课程页面需要登录
    },
    {
        path: '/questionCourse/detail/:courseId/:classId',
        name: 'questionCourseDetail',
        component: courseQuestionDetail,
        meta: { requiresAuth: true }, // 题库课程详情页面需要登录
    },
    {
        path: '/questionCourse/chapterQuestion/:classId/:courseId/:chapterId',
        name: 'chapterQuestion',
        component: chapterQuestion,
        meta: { requiresAuth: true }, // 章节练习页面需要登录
    },
    {
        path: '/questionCourse/quiuzQuestion/:paperId',
        name: 'quiuzQuestion',
        component: quiuzQuestion,
        meta: { requiresAuth: true }, // 模拟考试页面需要登录
    },
    {
        path: '/paperRecord',
        name: 'paperRecord',
        component: paperRecord,
        meta: { requiresAuth: true }, // 考试记录页面需要登录
    },
    {
        path: '/paperRecord/paperReport/:reportId',
        name: 'paperReport',
        component: paperReport,
        meta: { requiresAuth: true }, // 考试报告页面需要登录
    },
    {
        path: '/courseDetail/:classId/:courseId/:chapterId',
        name: 'courseDetail',
        component: courseDetail,
        meta: { requiresAuth: true }, // 课程详情页面需要登录
    },
    {
        path: '/404',
        name: '404',
        component: error404,
    },
    {
        path: '/:pathMatch(.*)',
        redirect: '/404'
    },

]

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
    return routerReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router
